import * as apiService from "./apiService";
import { WIDGET_PUBLIC } from "../../constants/v2/endPoints";

// Public, key-scoped widget API (no JWT; gating is server-side by widgetKey).

export async function getWidgetConfig(widgetKey) {
  return await apiService.apiCallWithoutToken(
    `${WIDGET_PUBLIC}/${encodeURIComponent(widgetKey)}/config`,
    "GET",
    {},
  );
}

export async function getWidgetWantAds(widgetKey, { sortType, page } = {}) {
  const params = {};
  if (sortType) params.sortType = sortType;
  if (page) params.page = page;
  return await apiService.apiCallWithoutToken(
    `${WIDGET_PUBLIC}/${encodeURIComponent(widgetKey)}/wantads`,
    "GET",
    params,
  );
}
